import { gql, gaia } from '@yi/core';

const { hasDatePassedUTC } = gaia;

export type MembershipStatus = {
  isMembershipActive: boolean;
  isMembershipLapsed: boolean;
  isMembershipCanceled: boolean;
  isMembershipPastDue: boolean;
  isMembershipTrialing: boolean;
  hasPaymentMethod: boolean;
};

export const getMembershipStatus = (
  subscription: gql.typesClient.Query_CurrentUserSubscription_CurrentUserSubscription | null,
): MembershipStatus => {
  const status = subscription?.sub_status;

  const ptdDateString: string | null = subscription?.next_assessment_at; // @TODO fix codegen type `any`
  const ptd = ptdDateString && new Date(ptdDateString);
  const futurePaidThroughDate = ptd ? !hasDatePassedUTC(ptd) : false;

  const isMembershipActive =
    (status === 'active' || status === 'trialing') &&
    futurePaidThroughDate &&
    subscription?.last_transaction_status === gql.typesClient.TransactionStatus.APPROVED;

  const isMembershipLapsed = (futurePaidThroughDate && subscription?.cancel_at_period_end) ?? false;

  const isMembershipCanceled = !futurePaidThroughDate && status === 'canceled';

  const isMembershipPastDue =
    !futurePaidThroughDate &&
    (subscription?.sub_status === 'active' ||
      subscription?.sub_status === 'trialing' ||
      subscription?.sub_status === 'past_due') &&
    subscription?.last_transaction_status === gql.typesClient.TransactionStatus.DECLINED;

  const isMembershipTrialing =
    status === 'trialing' &&
    !isMembershipLapsed &&
    !isMembershipPastDue &&
    !!subscription?.next_plan;

  const hasPaymentMethod =
    subscription?.masked_card_number ||
    subscription?.card_type ||
    (subscription?.payment_type && subscription?.payment_type !== 'Other');

  return {
    isMembershipActive,
    isMembershipLapsed,
    isMembershipCanceled,
    isMembershipPastDue,
    isMembershipTrialing,
    hasPaymentMethod: Boolean(hasPaymentMethod),
  };
};
